<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <div class="formItemBox">
        <el-form-item label="收款时间:">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分子公司:">
          <el-select v-model="searchForm.companyCode" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门:">
          <el-select v-model="searchForm.businessUnitCode" filterable clearable placeholder="请选择" @change="bumenChange">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务人员:">
          <el-select v-model="searchForm.businessUserId" filterable clearable placeholder="请选择">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称:">
           <el-input size="mini" v-model.trim="searchForm.customerName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="预警状态:">
          <el-select v-model="searchForm.warnState" clearable placeholder="请选择">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="已预警" :value="2"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" highlight-current-row
      center border show-summary :summary-method="getSummaries" :span-method="objectSpanMethod">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="createSubcompanyName" label="分子公司" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="businessUnit" label="部门" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="payee" label="客户名称" min-width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="预警状态" min-width="100" :show-overflow-tooltip="true">
          <template slot-scope="{ row }">
            <span class="warn-dot" :class="row.warnStateName === '正常' ? 'warn-dot-green' : (row.warnStateName === '已预警' ? 'warn-dot-yellow' : '')"></span>
            <span>{{ row.warnStateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="businessUser" label="业务人员" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ysPaymentTime" label="收款时间" :formatter="dateTimeFormat" min-width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="wayNum" label="业务单数" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="liquidatedAmountSum" label="业务量" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="grossNoRevenueSum" label="不含税总收入" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="freightNoTaxTotalSum" label="不含税总支出" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mlrAmount" label="毛利" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { businessSales, findCustomerInfoList } from '@/api/newTMS'
import { getDepartmentUsers, getCurrUserDepartment, getCurrUserRightCompany } from '@/api/newCrm'
import { emptyFn, toFixed, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'YewuTichengYijubiao',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateRange: [],
      searchForm: {
        startTimeStr: '',
        endTimeStr: '',
        companyCode: '',
        departmentCode: '',
        businessUnitCode: '',
        customerName: '',
        warnState: 0
      },
      tableList: [],
      spanArr: [],
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      isDaoChu: false,
      getCompany: [],
      bumenList: [],
      yonghuList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yewutichengyijubiao')
    // 初始化默认时间范围（最近30天）
    this.dateRange = this.getDefaultDateRange()
    if (this.dateRange && this.dateRange.length === 2) {
      this.searchForm.startTimeStr = this.dateRange[0]
      this.searchForm.endTimeStr = this.dateRange[1]
    }
    getCurrUserRightCompany().then(res => { this.getCompany = res })
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {

    // 获取默认日期范围（最近30天）
    getDefaultDateRange () {
      const today = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 29)
      const format = (d) => {
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }
      return [format(thirtyDaysAgo) + ' 00:00:00', format(today) + ' 23:59:59']
    },
    // 日期范围变化
    dateRangeChange (val) {
      if (!val || val.length !== 2) {
        this.searchForm.startTimeStr = ''
        this.searchForm.endTimeStr = ''
        return
      }
      const [start, end] = val
      // 验证时间跨度不超过1年
      const startDate = new Date(start)
      const endDate = new Date(end)
      const oneYearLater = new Date(startDate)
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1)
      if (endDate > oneYearLater) {
        this.$message.warning('时间跨度不可超过1年')
        this.dateRange = []
        this.searchForm.startTimeStr = ''
        this.searchForm.endTimeStr = ''
        return
      }
      this.searchForm.startTimeStr = start
      this.searchForm.endTimeStr = end
    },
    // 子公司更改
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e, isQueryDept: 0 }).then(res => { this.bumenList = res })
      this.$set(this.searchForm, 'businessUnitCode', '')
      this.$set(this.searchForm, 'businessUserId', '')
      this.yonghuList = []
    },
    // 部门更改 — 联动业务人员
    bumenChange (e) {
      if (e) {
        getDepartmentUsers({ orgCode: e,
          bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
        this.$set(this.searchForm, 'businessUserId', '')
      } else {
        this.yonghuList = []
      }
    },
    // 毛利率格式化
    formatPercent (row, column, cellValue) {
      if (cellValue === null || cellValue === undefined || cellValue === '') return '-'
      const str = String(cellValue)
      if (str.includes('%')) return str
      const num = Number(cellValue)
      if (isNaN(num)) return str
      return toFixed(num, 2) + '%'
    },
    // 指定列求和
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '-'
          return
        }
        if (column.property === 'createSubcompanyName') {
          sums[index] = '合计'
          return
        }
        // 非数值列显示 -
        if (['businessUnit', 'payee', 'businessUser', 'ysPaymentTime', 'warnStateName'].includes(column.property)) {
          sums[index] = '-'
          return
        }
        if (!column.property) {
          sums[index] = '-'
          return
        }
        // 毛利率不合计
        if (column.property === 'mllTax') {
          sums[index] = '-'
          return
        }
        // 数值列求和
        const values = data.map(item => Number(item[column.property]))
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
      })
      // 格式化数值
      return sums.map((item, index) => {
        if (typeof item === 'number') {
          // 业务单数取整
          const col = columns[index]
          if (col && col.property === 'num') {
            return Math.round(item).toString()
          }
          return toFixed(item, 2)
        }
        return item
      })
    },
    // 重新计算高度
    getgaodu () {
      this.$nextTick(() => {
        if (this.$refs.searchBox) {
          let h = this.$refs.searchBox.offsetHeight
          let pH = document.documentElement.clientHeight
          this.h = (pH - h - 140) + 'px'
          if (this.$refs.table) {
            this.$refs.table.doLayout()
          }
        }
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'createSubcompanyName' || column.property === 'businessUnit') {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    // 生成合并规则数组（按分子公司+部门合并）
    getSpanArr (data) {
      this.spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          if (item.businessUnit === data[index - 1].businessUnit &&
              item.createSubcompanyName === data[index - 1].createSubcompanyName) {
            this.spanArr[pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      businessSales(this.searchForm)
        .then(res => {
          this.tableList = res || []
          this.getSpanArr(this.tableList)
          this.getgaodu()
          loading.close()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      if (!this.searchForm.startTimeStr || !this.searchForm.endTimeStr) {
        this.$message.warning('请选择收款时间')
        return
      }
      this.masterList()
    },
    // 重置
    resetForm () {
      this.dateRange = this.getDefaultDateRange()
      this.searchForm = {
        startTimeStr: this.dateRange[0],
        endTimeStr: this.dateRange[1],
        companyCode: '',
        departmentCode: '',
        businessUnitCode: '',
        customerName: '',
        warnState: 0
      }
      this.bumenList = []
      this.yonghuList = []
      this.searchFn()
    },
    // 导出
    exportFn () {
      if (!this.searchForm.startTimeStr || !this.searchForm.endTimeStr) {
        this.$message.warning('请选择收款时间')
        return
      }
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/rCustomer/exportBusinessSalesReport',
        form,
        '业务提成报表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-table__footer-wrapper tbody td {
  color: #409EFF;
  font-weight: bold;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
.warn-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
.warn-dot-green {
  background-color: #67C23A;
}
.warn-dot-yellow {
  background-color: #E6A23C;
}
</style>
